<template>
  <span>
    <span v-if="!taskType" class="tag is-light" title="Het adres heeft geen schouw- of installatietaak">
      Onbekend
    </span>
    <span v-else-if="isLoading" class="has-text-grey">Laden...</span>
    <span v-else :class="['tag', tag.tagClass]">{{ tag.label }}</span>
  </span>
</template>

<script setup>
// The ODA status of the address. For now it comes with the detail of the installation (or
// inspection) task, which already asks Eleena for it: no separate endpoint yet.
import { computed } from 'vue'
import { useTaskDetail } from './composables/useTaskDetail'
import { odaStatusTag, ODA_UNKNOWN } from '@/util/odaStatus'

const props = defineProps({
  address: { type: String, required: true },
  // the task types of the address (keys of client.tasks)
  taskTypes: { type: Array, default: () => [] },
  project: { type: String, default: null },
})

const taskType = computed(() =>
  ['installation', 'inspection'].find((type) => props.taskTypes.includes(type)) || null
)

const { data: components, isInitialLoading: isLoading } = useTaskDetail(
  computed(() => props.address),
  taskType,
  computed(() => props.project)
)
const data = computed(() => components.value?.oda_status ?? null)

const tag = computed(() => (data.value ? odaStatusTag(data.value) : ODA_UNKNOWN))
</script>
